<template>
  <div class="container-custom" v-if="category !== null">
    <!-- breadcrumbs -->
    <Breadscrumbs
      :links="[
        {
          name: 'Category',
          to: {
            name: 'Category'
          }
        },
        {
          name: 'Create',
          to: {
            name: 'CategoryCreate'
          }
        },
      ]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>新增分類</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>
    <!-- block -->
    <div class="block">
      <!-- Category Name -->
      <label class="form-item py-5 d-flex">
        <h4 class="w-240px mr-10">Category Name</h4>
        <div class="form-input-group w-248px my-n2">
          <input type="text" placeholder="請輸入分類名稱" v-model="category.name"/>
        </div>
      </label>
      <!-- Category Subtitle -->
      <label class="form-item py-5 d-flex">
        <h4 class="w-240px mr-10">Subtitle 副標</h4>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="category.subtitle"
            placeholder="請輸入副標"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- BU -->
      <div class="form-item py-5 d-flex">
        <h4 class="w-240px mr-10">BU</h4>
        <div class="w-248px my-n2 category-autocomplete">
          <v-autocomplete
            v-model="category.bu_id"
            :items="buTabs"
            placeholder="請選擇所屬BU"
            item-text="name"
            item-value="id"
            outlined
            dense
          >
          </v-autocomplete>
        </div>
      </div>
      <!-- ID -->
      <label class="form-item py-5 d-flex">
        <h4 class="w-240px mr-10">ID</h4>
        <div class="d-flex">
          <div class="form-input-group w-248px my-n2">
            <input type="text" value="" disabled />
          </div>
          <div class="h5 ink-02-medium--text ml-10px">(自動生成)</div>
        </div>
      </label>
      <!-- Order -->
      <label class="form-item py-5 d-flex">
        <div class="w-240px mr-10">
          <h4 class="mb-10px">Order</h4>
          <div class="h5 ink-02-medium--text">
            資料降冪排序(數字越大顯示越前面)
          </div>
        </div>
        <div class="form-input-group w-248px my-n2">
          <input type="text" placeholder="請輸入序號" v-model="category.order"/>
        </div>
      </label>
      <!-- 顯示/隱藏 -->
      <label class="form-item py-5 d-flex">
        <div class="w-240px mr-10">
          <h4>顯示/隱藏</h4>
        </div>
        <div>
          <FormSwitch v-model="category.status"></FormSwitch>
        </div>
      </label>
      <!-- URL -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px mr-10">
          <h4>Slug</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="category.slug"
            placeholder="可讀性URL"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- SEO TITLE -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px mr-10">
          <h4>SEO Title</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="category.seo_title"
            placeholder="SEO Title"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- SEO Keyword -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px mr-10">
          <h4>SEO Keywords</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-textarea
            v-model="category.seo_keyword"
            outlined
            dense
          ></v-textarea>
        </div>
      </label>
      <!-- SEO Description -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px mr-10">
          <h4>SEO Description</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-textarea
            v-model="category.seo_description"
            outlined
            dense
          ></v-textarea>
        </div>
      </label>
      <!-- 首頁圖片 -->
      <div class="form-item py-5 d-flex">
        <div class="w-240px mr-10">
          <h4 class="mb-10px">首頁圖片</h4>
          <div class="h5 ink-02-medium--text">
            此圖將顯示於官網首頁 <br />
            建議尺寸：350px * 250px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div>
          <ImgUploader
            :imageUrl.sync="category.image"
            dir="category"></ImgUploader>
        </div>
      </div>
      <!-- 分類預設頁 -->
      <div class="form-item py-5 d-flex">
        <div class="w-240px mr-10">
          <h4 class="mb-10px">分類預設頁</h4>
          <div class="h5 ink-02-medium--text">
            此圖將顯示於分類Page <br />
            建議尺寸：620px * 430px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div>
          <ImgUploader
            :imageUrl.sync="category.cover_image"
            dir="category"></ImgUploader>
        </div>
      </div>
      <!-- img uploader -->
      <div class="form-item d-flex px-5 py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-10px">Detail Page Banner</h4>
          <div class="h5 ink-02-medium--text">
            呈現於Detail Page置頂區 <br />
            建議尺寸：999px * 999px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div class="d-flex flex-grow-1">
          <ImgUploader
            :imageUrl.sync="category.detail_page_banner"
            dir="category"></ImgUploader>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import FormSwitch from '@/components/FormSwitch.vue';
import ImgUploader from '@/components/ImgUploader.vue';
import Breadscrumbs from '@/components/Breadscrumbs.vue';

export default {
  components: {
    FormSwitch,
    ImgUploader,
    Breadscrumbs,
  },
  computed: {
    ...mapState(['buTabs']),
    ...mapState('category', ['category']),
  },
  async created() {
    this.setCategory({});
  },
  methods: {
    ...mapActions('category', {
      setCategory: 'setCategory',
      save: 'save',
      clear: 'clear',
    }),
    cancelHandler() {
      this.$router.push({ name: 'Category' });
    },
    saveHandler() {
      this.save(this.category).then(() => {
        this.$router.push({ name: 'Category' });
        this.clear();
      });
    },
  },
};
</script>

<style lang="scss">
.category-autocomplete {
  .v-autocomplete {
    .v-input__slot {
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
    .v-text-field__details {
      display: none;
    }
  }

  // border
  fieldset {
    border-color: #d7dee7;
    border-radius: 8px;
  }
  .v-input--is-focused {
    border-color: $brand-500;
  }

  // placeholder color
  input::placeholder {
    color: #848fa0 !important;
  }
}
</style>
